import { render, staticRenderFns } from "./DigitalizeYourCompany.vue?vue&type=template&id=2deaa188&scoped=true"
import script from "./DigitalizeYourCompany.vue?vue&type=script&lang=js"
export * from "./DigitalizeYourCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deaa188",
  null
  
)

export default component.exports